import React, { useState } from "react";
import { CommonBohoModalTitle } from "../Common/CommonBohoModalTitle";
import { Btn, H3, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { Col } from "reactstrap";
import CommonModal from "../../Common/CommonModal";
import { StaticForm } from "../../StaticBackdropModal/StaticForm";
import { BohoLogin, ClickOut } from "../../../../../Constant";

const ModalTwo = () => {
    const [modalTwo, setModalTwo] = useState(false);
    const modalTwoTogggle = () => setModalTwo(!modalTwo);
    return (
      <Col xl="4" md="6" className="custom-alert text-center">
        <div className="card-wrapper border rounded-3 h-100">
          <div className="Boho-demo-img">
            <CommonBohoModalTitle heading="Modal 2 -" subHeading="Result Modal" text="Example of Boho login form." />
            <div className="overflow-hidden">
              <Image className="image-fluid" src={dynamicImage("alert/learning.png")} alt="learning" />
              <Btn color="primary" className="mx-auto mt-3" type="button" onClick={modalTwoTogggle}>{ClickOut}</Btn>
            </div>
            <CommonModal centered modalBodyClassName="social-profile text-start" fade={true} isOpen={modalTwo} toggle={modalTwoTogggle}>
            <div className="modal-toggle-wrapper">
              <H3>{BohoLogin}</H3>
              <P>Fill in your information below to continue.</P>
              <StaticForm staticModalToggle={modalTwoTogggle} />
            </div>
          </CommonModal>
          </div>
        </div>
      </Col>
    );
};

export default ModalTwo;
